// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__1ILHY","taskSucceeded":"style_taskSucceeded__1Gmxs","title":"style_title__UwJjE","taskFailed":"style_taskFailed__eD3aY","taskTime":"style_taskTime__1Y3GB"};